<template>
    <div class="aps">
        <div class="sitecontent">
            <div class="inr_banner"></div>
        </div>
        <div class="npagePage introduction">
            <div class="intro_cont">
                <div class="container">
                    <div class="clearfix row">
                        <div class="intro_tab-content tab-content">
                            <div class="intro_panel-01">
                                <div class="tab-pane_na wow fadeInUp animated"
                                    style="visibility: visible; animation-name: fadeInUp;">
                                    <div class="clearfix row">
                                        <div class="header_title">
                                            <p class="title">面向普通外卖商户</p>
                                        </div>
                                    </div>
                                    <div class="clearfix row">
                                        <div class="clearfix text_cont">
                                            <img src="/static/img/appimg1.jpg" alt="自动接单打印机" class="fl" />
                                            <div class="text_div text1 fl text_fr">
                                                <p>众联云打印机提供众联云助手，商户购买打印机后，轻松即可绑定店铺。</p>
                                                <p>支持以下平台：</p>
                                                <p>
                                                    <img src="/static/img/appimg3.jpg" alt="平台外卖接单" />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane_na mt20">
                                    <div class="clearfix row wow fadeInUp animated"
                                        style="visibility: visible; animation-name: fadeInUp;">
                                        <h3 class="header_title">
                                            <p class="title">面向软件开发商</p>
                                        </h3>
                                    </div>
                                    <div class="clearfix row">
                                        <div class="clearfix text_cont wow fadeInUp animated"
                                            style="visibility: visible; animation-name: fadeInUp;">
                                            <img src="/static/img/appimg2.jpg" alt class="fl" />
                                            <div class="text_div text3 fl text_fr">
                                                <p>
                                                    <span>1</span>众联云开放平台对外开放API接口，给开发人员带来了极大的方便，只需30分钟即可完成对接，API接口支持PHP、Java、NodeJS等语言;
                                                </p>
                                                <p>
                                                    <span>2</span>软件开发商对接打印机时，免费给客户提供技术支持;
                                                </p>
                                                <p>
                                                    <span>3</span>打印机可自定义打印内容和格式，支持二维码、条形码、LOGO打印等；
                                                </p>
                                                <p>
                                                    <span>4</span>提供网页版开发者中心，轻松管理订单与机器。
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane_na mt20">
                                    <div class="clearfix row wow fadeInUp animated"
                                        style="visibility: visible; animation-name: fadeInUp;">
                                        <h3 class="header_title">
                                            <p class="title">场景案例展示</p>
                                        </h3>
                                    </div>
                                    <div class="clearfix row wow fadeInUp animated"
                                        style="visibility: visible; animation-name: fadeInUp;">
                                        <div class="clearfix text_cont">
                                            <div class="text_div text4 fl text_fr">
                                                <p class="img tc">
                                                    <img src="/static/img/animg1.jpg" alt="餐饮打印机小票" />
                                                </p>
                                                <br />
                                                <p class="ti tc">餐饮店：外卖后厨小票打印</p>
                                                <p class="cont">
                                                    打印机支持多种餐饮软件，一台打印机完成多个平台订单
                                                    <br />无需连接电脑、手机、蓝牙，节约成本压力
                                                    <br />自动接单、自动打印，真正省时省力省心
                                                    <br />打印机放在前台和后厨能同时出单，更加便利高效
                                                </p>
                                            </div>
                                            <div class="text_div text4 fl text_fr">
                                                <p class="img tc">
                                                    <img src="/static/img/animg2.jpg" alt="收银台打印机小票" />
                                                </p>
                                                <br />
                                                <p class="ti tc">收银台：超市小票打印</p>
                                                <p class="cont" style="padding-top: 20px;">
                                                    打印机能对接云收银系统，即插即用
                                                    <br />打印机只需连接WiFi或GPRS网络，无需配备电脑，节省成本
                                                    <br />自动打印订单功能，进一步提升收银效率
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clearfix row wow fadeInUp animated"
                                        style="visibility: visible; animation-name: fadeInUp;">
                                        <div class="clearfix text_cont" style="padding-top: 0px;">
                                            <div class="text_div text4 fl text_fr">
                                                <p class="img tc">
                                                    <img src="/static/img/animg3.jpg" alt="药店打印机小票" />
                                                </p>
                                                <br />
                                                <p class="ti tc">药店：药品小票打印</p>
                                                <p class="cont" style="padding-top: 20px;">
                                                    打印机是药店经营的得力帮手，使用中需要接入小票打印机
                                                    <br />无需配备电脑，节省成本，提供用户销售凭证
                                                    <br />自动打印订单功能，快速结账
                                                </p>
                                            </div>
                                            <div class="text_div text4 fl text_fr">
                                                <p class="img tc">
                                                    <img src="/static/img/animg4.jpg" alt="加油站打印机小票" />
                                                </p>
                                                <br />
                                                <p class="ti tc">加油站：订单发票打印</p>
                                                <p class="cont">
                                                    扫码加油，手机支付，自动打印小票
                                                    <br />无需下车，既可完成加油，极大提高司机加油体验。
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() { return {} }

}
</script>


<style scoped>
.mt20 {
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// aps.vue?8b2d1910